import axios from 'axios'
import { toast } from 'react-toastify'
import { BASE_URL } from 'src/constants/enviroments'

export const API = axios.create({
  baseURL: BASE_URL
})

export const confirmEmail = async (username: string) => {
  return API.post('/enviarCodigoConfirmacao', { tipo: 'EMAIL', username }, { skipAuth: true }).catch(() => {
    toast.error('Ocorreu um erro ao enviar o código, tente novamente.')
  })
}

export const validateEmail = async (username: string, codigo) => {
  return API.post('/validarCodigoConfirmacao', { tipo: 'EMAIL', username, codigo }, { skipAuth: true }).catch(() => {
    toast.error('Código inválido')
  })
}
